// Defensive auth-storage helpers. These never throw, even if localStorage
// has been corrupted (e.g. the literal string "undefined" left behind by
// an earlier bug). Any bad data is silently cleared so the app can recover
// on the next render instead of white-screening.

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

const isBadString = (value) =>
  value === null ||
  value === undefined ||
  value === 'undefined' ||
  value === 'null' ||
  value === '';

export const setAuthData = (token, user) => {
  try {
    if (isBadString(token)) {
      localStorage.removeItem(TOKEN_KEY);
    } else {
      localStorage.setItem(TOKEN_KEY, token);
    }

    if (user === undefined || user === null) {
      localStorage.removeItem(USER_KEY);
    } else {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    }
  } catch (e) {
    // localStorage may be unavailable (private mode, quota, etc.)
    // Fail silently — auth simply won't persist across reloads.
    // eslint-disable-next-line no-console
    console.warn('setAuthData failed:', e);
  }
};

export const getAuthData = () => {
  let token = null;
  let user = null;

  try {
    const rawToken = localStorage.getItem(TOKEN_KEY);
    token = isBadString(rawToken) ? null : rawToken;
  } catch (e) {
    token = null;
  }

  try {
    const rawUser = localStorage.getItem(USER_KEY);
    if (!isBadString(rawUser)) {
      try {
        user = JSON.parse(rawUser);
      } catch (parseErr) {
        // Corrupted user payload — purge it so we never hit this again.
        // eslint-disable-next-line no-console
        console.warn('Corrupted user data in localStorage, clearing.', parseErr);
        try {
          localStorage.removeItem(USER_KEY);
        } catch (_) {
          /* ignore */
        }
        user = null;
      }
    }
  } catch (e) {
    user = null;
  }

  return { token, user };
};

export const clearAuthData = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (e) {
    /* ignore */
  }
};

export const isAuthenticated = () => {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    return !isBadString(raw);
  } catch (e) {
    return false;
  }
};
